import { TextInput } from '../baseInputs'

type Props = {
  helper?: string
  name?: string
  label?: string
}

const FirstName = ({ helper, name, label, ...rest }: Props) => {
  return (
    <TextInput
      name={name || 'first_name'}
      label={label || 'First name'}
      helper={helper}
      {...rest}
    />
  )
}

export default FirstName
